<template>
  <v-tabs hide-slider :value="value" @change="v => $emit('input', v)">
    <v-tab>Input spec</v-tab>
    <v-tab>Project input data</v-tab>
    <v-tab>Builder resources</v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: 'input-section-tabs',
  props: [ 'value' ]
}
</script>
